import { apiService } from "./apiService";
import { INotificationResponse } from "src/modules/Auth/store/types";

export const NotificationsService = {
    get: (): Promise<INotificationResponse> => {
        return apiService.get(`api/notifications`).then(res => {
            const { data } = res;
            return res.status === 200 && data.notifications ? data.notifications as INotificationResponse : {};
        });
    },
    remove: (ids: string[]): Promise<any> => {
        return apiService.delete(`api/notifications`, { data: { request: { ids } } }).then(res => {
            const { data } = res;
            return res.status === 200 && data ? data : null;
        });
    }
}


// WEBPACK FOOTER //
// ./src/share/services/notifications.ts